const LOADING_HEADING = [
  "Wasserstart läuft",
  "leite Halse ein",
  "Gleite an, einen Moment",
  "fahre Powerhalse",
  "Flaka im Anflug",
  "Burner am rotieren",
  "Flaute, es dauert kurz",
  "Böe im Anflug",
  "Winddreher abwarten",
  "Druck baut sich erst auf",
  "Segel hat noch keinen Druck",
  "Leichtwindmodus aktiv",
  "Stehsegeler, einen Moment bitte",
];

const LoadingPage = () => {
  return (
    <div className="safe-top-with-hanger safe-bottom-with-dock w-full min-h-screen flex justify-center items-center ">
      <main className="flex flex-col justify-center gap-8 items-center w-full h-screen bg-base-100 ">
        <div className="relative flex flex-col items-center space-y-4">
          <span className="text-xl font-bold text-base-content skeleton skeleton-text">
            {
              LOADING_HEADING[
                Math.floor(Math.random() * LOADING_HEADING.length)
              ]
            }
          </span>
          <progress className="progress w-56"></progress>
        </div>
        <div className="avatar">
          <div className="mask mask-heart w-24 skeleton animate-pulse">
            <img src="/apple-touch-icon.png" loading="lazy" />
          </div>
        </div>
      </main>
    </div>
  );
};
export default LoadingPage;
